import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import { ACTIVITY_TYPE, HttpStatus } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";
import ManagementMekanikDetail from "./components/managementMekanikDetail";
import { tableConfig } from "./config";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
class ManagementMekanik extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
      selectedCabang: null,
      isLoading: false,
      dataTable: [],
      pagination: {
        limit: 5,
        page: 1,
        totalData: 0,
      },
      detail: {
        visible: false,
        id: null,
        activityType: null,
      },
      skipNextFetch: false,
      alertInfo: {
        visible: false,
        title: null,
        content: null,
        action: null,
        data: null,
      },
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCabang = prevState.selectedCabang?.value;
    const currCabang = this.state.selectedCabang?.value;
    if (prevCabang !== currCabang) {
      this.setState({
        pagination:{
          limit: 5,
          page: 1,
          totalData: 0
        }
      }, () => this.fetchData())
    }

    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;

    if (
      (prevPagination.limit !== currPagination.limit ||
        currPagination.page !== prevPagination.page) &&
      !this.state.skipNextFetch
    ) {
      this.fetchData();
    }
    if (this.state.skipNextFetch) {
      this.setState({ skipNextFetch: false });
    }
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, isLoading: !prev.isLoading }));
  };

  fetchData = async (filter = {}, limit, page) => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION")
        .getDataMechanicManagementMainPage,
      menuName: "Management Mekanik",
      setError: this.props.setError,
      args: {
        limit: limit || this.state.pagination?.limit,
        page: page || this.state.pagination?.page,
        kodeCabang: this.state.selectedCabang?.value,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
    this.handleTriggerLoading();
  };

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Master Mekanik",
      args: null,
    });
    if (res.ok) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang)
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          cabangOptions: filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          ),
          selectedCabang: mapToObjectDDL(
            filteredData[0].namaDealer,
            filteredData[0].kodeCabang
          ),
          userAccess: getUserAccess(
            this.props.menuAccess,
            filteredData[0].kodeCabang
          ),
        }));
      }
    }
    this.handleTriggerLoading();
  };

  handleValueChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  handleDetailVisibility = (id, activityType) => {
    this.setState((prev) => ({
      ...prev,
      detail: {
        ...prev.detail,
        visible: !prev.detail.visible,
        id: id,
        activityType: activityType,
      },
    }));
  };

  handleRefresh = () => {
    this.setState((prev) => ({
      ...prev,
      skipNextFetch: true,
    }));
    this.fetchData();
  };

  getTableConfig = () => {
    return tableConfig({
      onDetailVisibilityChange: this.handleDetailVisibility,
      userAccess: this.state.userAccess
    });
  };

  handleChangePage = (tableState) => {
    const limit = tableState.rowsPerPage;
    const page = tableState.page + 1;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
        limit: limit,
      },
    }));
  };

  handleChangeRowsPerPage = (tableState) => {
    const limit = tableState.rowsPerPage;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        totalData: 0,
        page: 1,
        limit: limit,
      },
    }));
  };

  handleAlertInfoVisibility = (title, content, action, data) => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: !prev.alertInfo.visible,
        title: title,
        content: content,
        action: action,
        data: data,
      },
    }));
  };

  render() {
    const {
      cabangOptions,
      selectedCabang,
      isLoading,
      dataTable,
      detail,
      userAccess,
      pagination,
      alertInfo,
    } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <p className="margin margin-bottom-15px">Cabang</p>
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="selectedCabang"
              containerclassname="width width-280px"
              placeholder="Nama cabang hak akses"
              options={cabangOptions}
              value={selectedCabang}
              onChange={(value, { name }) =>
                this.handleValueChange(name, value)
              }
            />
          </FlexView>
          <SimpleDataTable
            data={dataTable}
            columns={this.getTableConfig()}
            toCount={pagination.totalData}
            rowsPerPage={pagination.limit}
            page={pagination.page - 1}
            options={defaultTableChange(
              this.handleChangePage,
              this.handleChangeRowsPerPage
            )}
            footerAdditionalButtons={
              <SimpleButton
                type="button"
                text="Tambah"
                secondary={!userAccess?.createAccess}
                disabled={!userAccess?.createAccess}
                icon={<i className="fa fa-plus margin margin-right-5px" />}
                onClick={() =>
                  this.handleDetailVisibility(null, ACTIVITY_TYPE.CREATE)
                }
              />
            }
          />
        </Container>
        {detail.visible && (
          <ManagementMekanikDetail
            {...this.props}
            handleAlertInfo={this.handleAlertInfoVisibility}
            visible={detail.visible}
            onClickClose={this.handleDetailVisibility}
            selectedCabang={selectedCabang}
            activityType={detail.activityType}
            selectedId={detail.id}
            onRefresh={this.handleRefresh}
            handleTriggerLoading={this.handleTriggerLoading}
          />
        )}
        {alertInfo.visible && (
          <SimpleAlert
            visible={alertInfo.visible}
            title={alertInfo.title}
            content={alertInfo.content}
            onClickClose={() => this.handleAlertInfoVisibility()}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleAlertInfoVisibility()}
              />
            }
          />
        )}
        {isLoading && <SimpleLoadingOverlay active={isLoading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(ManagementMekanik);
